var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "app-main"
  }, [(_vm.products && _vm.products.length) ? _c('section', {
    staticClass: "products allproducts"
  }, [_c('h1', {
    staticClass: "allproducts__title"
  }, [_vm._v("Продукти")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row l-wrap l-flex-center l-items-baseline"
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      class: ['product l-s', ( _obj = {}, _obj[product.theme] = true, _obj )]
    }, [_c('div', {
      staticClass: "product__image"
    }, [_c('div', {
      staticClass: "item",
      attrs: {
        "data-path-scaleX": "0.7",
        "data-path-scaleY": "0.7",
        "data-path-rotate": "25",
        "data-animation-path-duration": "2000",
        "data-morph-path": "M 418.1,159.8 C 460.9,222.9 497,321.5 452.4,383.4 417.2,432.4 371.2,405.6 271.3,420.3 137.2,440 90.45,500.6 42.16,442.8 -9.572,381 86.33,289.1 117.7,215.5 144.3,153.4 145.7,54.21 212.7,36.25 290.3,15.36 373.9,94.6 418.1,159.8 Z"
      }
    }, [_c('div', {
      staticClass: "absolute-center"
    }, [_c('router-link', {
      staticClass: "product__link",
      attrs: {
        "to": '/product/' + product.slug + '/' + product.id
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.image + '?w=310&h=410',
        "alt": "Product"
      }
    })]), _vm._v(" "), _c('h2', {
      staticClass: "product__title"
    }, [_c('router-link', {
      staticClass: "product__link",
      attrs: {
        "to": '/product/' + product.slug + '/' + product.id
      }
    }, [_vm._v(_vm._s(product.title))])], 1)], 1), _vm._v(" "), _c('svg', {
      staticClass: "item__svg",
      attrs: {
        "width": "500px",
        "height": "500px",
        "viewBox": "0 0 500 500"
      }
    }, [_c('clipPath', {
      attrs: {
        "id": 'idp' + product.id
      }
    }, [_c('path', {
      staticClass: "item__clippath",
      attrs: {
        "d": "M 378.1,121.2 C 408.4,150 417.2,197.9 411,245.8 404.8,293.7 383.5,341.7 353.4,370.7 303.2,419.1 198.7,427.7 144.5,383.8 86.18,336.5 67.13,221.3 111.9,161 138.6,125 188.9,99.62 240.7,90.92 292.4,82.24 345.6,90.32 378.1,121.2 Z"
      }
    })]), _vm._v(" "), _c('g', {
      attrs: {
        "clip-path": 'url(#idp' + product.id + ')'
      }
    }, [_c('path', {
      attrs: {
        "d": "M0,0h600v600H0V0z"
      }
    })])])])])])
    var _obj;
  }))])]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77b674d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Products.vue
// module id = n9YS
// module chunks = 1